// Sayfa izinleri tanımları
// Her admin için hangi sayfalara erişebileceğini belirler

export interface PagePermission {
  key: string;
  label: string;
  path: string;
  category: string;
  description: string;
}

export const PAGE_PERMISSIONS: PagePermission[] = [
  // Kullanıcı Yönetimi
  {
    key: 'users',
    label: 'Kullanıcı Yönetimi',
    path: '/admin/users',
    category: 'Kullanıcı Yönetimi',
    description: 'Kullanıcıları görüntüle, düzenle ve yönet'
  },
  {
    key: 'matches',
    label: 'Eşleşmeler',
    path: '/admin/matches',
    category: 'Kullanıcı Yönetimi',
    description: 'Kullanıcı eşleşmelerini takip et'
  },
  {
    key: 'map',
    label: 'Konum Haritası',
    path: '/admin/map',
    category: 'Kullanıcı Yönetimi',
    description: 'Kullanıcı konumlarını haritada görüntüle'
  },
  {
    key: 'chats',
    label: 'Sohbetler',
    path: '/admin/chats',
    category: 'Kullanıcı Yönetimi',
    description: 'Kullanıcı sohbetlerini izle'
  },
  {
    key: 'reports',
    label: 'Şikayetler',
    path: '/admin/reports',
    category: 'Kullanıcı Yönetimi',
    description: 'Kullanıcı şikayetlerini yönet'
  },
  {
    key: 'deleted-accounts',
    label: 'Silinmiş Hesaplar',
    path: '/admin/deleted-accounts',
    category: 'Kullanıcı Yönetimi',
    description: 'Silinen kullanıcıları yönet'
  },

  // Oyun & Ödüller
  {
    key: 'game-management',
    label: 'Oyun Yönetimi',
    path: '/admin/game-management',
    category: 'Oyun & Ödüller',
    description: 'Kahve oyunu sorularını yönet'
  },
  {
    key: 'vs-questions',
    label: 'VS Kapışma Soruları',
    path: '/admin/vs-questions',
    category: 'Oyun & Ödüller',
    description: '1v1 kapışma sorularını yönet'
  },
  {
    key: 'winners-management',
    label: 'Kazananlar',
    path: '/admin/winners-management',
    category: 'Oyun & Ödüller',
    description: 'Oyun kazananlarını yönet'
  },
  {
    key: 'gift-cards',
    label: 'Gift Card Yönetimi',
    path: '/admin/gift-cards',
    category: 'Oyun & Ödüller',
    description: 'Gift card tanımları ve kodlar'
  },
  {
    key: 'beans',
    label: 'Coffee Bean Yönetimi',
    path: '/admin/beans',
    category: 'Oyun & Ödüller',
    description: 'Harita bean spawn yönetimi'
  },
  {
    key: 'letter-hint-pricing',
    label: 'Harf İpucu Fiyatlandırma',
    path: '/admin/letter-hint-pricing',
    category: 'Oyun & Ödüller',
    description: 'Oyun ipucu fiyatlarını ayarla'
  },

  // Kafe Yönetimi
  {
    key: 'partner-cafes',
    label: 'Partner Kafeler',
    path: '/admin/partner-cafes',
    category: 'Kafe Yönetimi',
    description: 'Kafe noktalarını yönet'
  },
  {
    key: 'partners',
    label: 'İş Ortakları',
    path: '/admin/partners',
    category: 'Kafe Yönetimi',
    description: 'Partner logolarını yönet'
  },
  {
    key: 'cafe-applications',
    label: 'Kafe Başvuruları',
    path: '/admin/cafe-applications',
    category: 'Kafe Yönetimi',
    description: 'Partnerlik başvurularını yönet'
  },
  {
    key: 'qr-statistics',
    label: 'QR Kod İstatistikleri',
    path: '/admin/qr-statistics',
    category: 'Kafe Yönetimi',
    description: 'Kafe QR kod taramaları'
  },
  {
    key: 'cafe-crm',
    label: 'Kafe CRM',
    path: '/admin/cafe-crm',
    category: 'Kafe Yönetimi',
    description: 'Kafe iletişim takibi'
  },
  {
    key: 'cafe-map',
    label: 'Kafeler Haritası',
    path: '/admin/cafe-map',
    category: 'Kafe Yönetimi',
    description: 'Tüm kafeleri haritada görüntüle'
  },
  {
    key: 'cafe-roi-dashboard',
    label: 'Kafe ROI Analizi',
    path: '/admin/cafe-roi-dashboard',
    category: 'Kafe Yönetimi',
    description: 'Kafe performansı ve değerlendirmeleri'
  },

  // İçerik & Moderasyon
  {
    key: 'posts',
    label: 'Post Yönetimi',
    path: '/admin/posts',
    category: 'İçerik & Moderasyon',
    description: 'Postları ve raporları yönet'
  },
  {
    key: 'comments',
    label: 'Yorum Yönetimi',
    path: '/admin/comments',
    category: 'İçerik & Moderasyon',
    description: 'Yorumları listele ve yönet'
  },
  {
    key: 'content-moderation',
    label: 'İçerik Moderasyonu',
    path: '/admin/content-moderation',
    category: 'İçerik & Moderasyon',
    description: 'Post ve yorum raporları yönetimi'
  },
  {
    key: 'linktree',
    label: 'Linktree Yönetimi',
    path: '/admin/linktree',
    category: 'İçerik & Moderasyon',
    description: 'Instagram ve sosyal medya için Linktree sayfasını yönet'
  },

  // İletişim & Bildirimler
  {
    key: 'notifications',
    label: 'Push Bildirimler',
    path: '/admin/notifications',
    category: 'İletişim & Bildirimler',
    description: 'Kullanıcılara bildirim gönder'
  },
  {
    key: 'feedback',
    label: 'Geri Bildirimler',
    path: '/admin/feedback',
    category: 'İletişim & Bildirimler',
    description: 'Kullanıcı geri bildirimleri'
  },
  {
    key: 'contacts',
    label: 'İletişim Mesajları',
    path: '/admin/contacts',
    category: 'İletişim & Bildirimler',
    description: 'Kullanıcı iletişim mesajları'
  },
  {
    key: 'notification-analytics',
    label: 'Bildirim Analizi',
    path: '/admin/notification-analytics',
    category: 'İletişim & Bildirimler',
    description: 'Push bildirim performansı'
  },

  // Analitik & Raporlar
  {
    key: 'analytics',
    label: 'Analitik',
    path: '/admin/analytics',
    category: 'Analitik & Raporlar',
    description: 'Detaylı istatistikleri görüntüle'
  },
  {
    key: 'marketing',
    label: 'Marketing & Growth',
    path: '/admin/marketing',
    category: 'Analitik & Raporlar',
    description: 'Meta Ads, büyüme ve dönüşüm analizi'
  },
  {
    key: 'retention-dashboard',
    label: 'Kullanıcı Elde Tutma',
    path: '/admin/retention-dashboard',
    category: 'Analitik & Raporlar',
    description: 'DAU/MAU, Churn ve Retention analizi'
  },

  // Sistem
  {
    key: 'firebase-data',
    label: 'Firebase Verileri',
    path: '/admin/firebase-data',
    category: 'Sistem',
    description: 'Tüm koleksiyonları görüntüle'
  },
  {
    key: 'backup',
    label: 'Veritabanı Yedekleme',
    path: '/admin/backup',
    category: 'Sistem',
    description: 'Veritabanı yedeklerini al, listele ve geri yükle'
  },
  {
    key: 'version',
    label: 'Uygulama Versiyon Kontrolü',
    path: '/admin/version',
    category: 'Sistem',
    description: 'iOS ve Android için zorunlu ve isteğe bağlı versiyon kısıtlamalarını ayarla'
  },
  {
    key: 'api-health',
    label: 'API Health Monitor',
    path: '/admin/api-health',
    category: 'Sistem',
    description: 'Backend & Firebase durumu'
  }
];

// Kategorilere göre grupla
export const getPermissionsByCategory = (): Record<string, PagePermission[]> => {
  return PAGE_PERMISSIONS.reduce((acc, permission) => {
    if (!acc[permission.category]) {
      acc[permission.category] = [];
    }
    acc[permission.category].push(permission);
    return acc;
  }, {} as Record<string, PagePermission[]>);
};

// Belirli bir sayfaya erişim kontrolü
export const hasPageAccess = (permissions: string[], pageKey: string, role: string): boolean => {
  // Super admin her şeye erişebilir
  if (role === 'super_admin') return true;

  // 'all' izni varsa her şeye erişebilir
  if (permissions.includes('all')) return true;

  // Sayfa key'i izinlerde var mı kontrol et
  return permissions.includes(pageKey);
};

// Tüm sayfa key'lerini getir
export const getAllPageKeys = (): string[] => {
  return PAGE_PERMISSIONS.map(p => p.key);
};
